import { defineStore } from "pinia";

export const useApiKeysStore = defineStore("apiKeysStore", {
  state: () => ({
    googleFontsApiKey: "",
  }),

  actions: {
    setGoogleFontsApiKey(key: string) {
      this.googleFontsApiKey = key;
    },
  },
});
